/** Stable question IDs keep answers attached to their question after renumbering. */
export const evaluationQuestionIds = Array.from({ length: 10 }, (_, index) => String(index + 1));

export function normalizeHiddenQuestions(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return evaluationQuestionIds.filter((id) => value.includes(id));
}

export function visibleEvaluationQuestions(hidden: readonly string[] = []) {
  return evaluationQuestionIds.filter((id) => !hidden.includes(id)).map((id, index) => ({ id, number: index + 1 }));
}
